import React, { Component } from "react";
import Tweet from "./Tweet";
import logo from "../trumper.png";
import db from "../firebase";

export default class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showing_warning: "hidden",
      posts: [
        {
          img: "",
          id: 99,
          likes: 2300000000,
          date: "12:22 - Jan 08 2021",
          text: "Twitter Who?",
        },
        {
          id: 6,
          text: "Dinosaurs are a lie!",
          img: "",
          likes: 4900000000,
          date: "12:45 - Jan 09 2021",
        },
        {
          img: "",
          id: 5,
          date: "13:47 Jan 09 2021",
          likes: 560000000,
          text: "I have never seen a thin person drinking Diet Coke",
        },
        {
          img: "https://i.imgflip.com/1iclio.jpg?a447000",
          text:
            "You wanna see an image of the real voting result? Here you go:",
          likes: 9100000000,
          id: 2,
          date: "12:53 - 10 Jan 2021",
        },
        {
          id: 1,
          likes: 215000000,
          text:
            "Why do I get only 23.1 Quintillion likes? I deserve more! Trumper should fix this or I will ban it!",
          img: "",
          date: "13:03 - Jan 10 2021",
        },
        {
          id: 0,
          date: "12:43 - Jan 10 2021",
          likes: 420000000,
          emoji: true,
          img: "",
          text:
            "I am the best president of all times. Chickens don't exist. Trump Tower is taller than Mount Everest. Facts!",
        },
        {
          date: "13:14 - Jan 10 2021",
          id: -1,
          text:
            'Last week I went to the doctor. Results came in: "Strongest and sexiest man of america." Tell me something new, doc!',
          img: "",
          likes: 456000000,
        },
        {
          id: -4,
          text: "Somebody give this man an award!",
          img: "https://i.gyazo.com/9ebec007562acccad4129a437d52673f.png",
          emoji: true,
          date: "09:21 - Jan 11 2021",
          likes: 3400000000,
        },
        {
          date: "15:21 - Jan 11 2021",
          id: -10,
          likes: 9750000000,
          img: "",
          text:
            "It's freezing and snowing in New York-- we need global warming!",
        },
      ],
    };
  }

  componentDidMount() {
    this.setState({ posts: this.state.posts.reverse() });
  }

  displayWarning = (e) => {
    this.setState({ showing_warning: "" });
    console.log("clicked");
    const fake_news = new Audio(
      "https://www.gisbefreit.at/js/files/fake_news.mp3"
    );
    fake_news.volume = 0.5;
    fake_news.play();
    const input = document.querySelector(".inputBox input");
    input.setAttribute("disabled", "");
    input.setAttribute("placeholder", "No fake news allowed.");
    e.target.style.animation = "shake 700ms";
    e.target.setAttribute("disabled", "");
    input.value = "";
  };

  render() {
    return (
      <div class="home">
        <div className="postContainer">
          <div className="topbar">
            <img src={logo} height="30" />
            Trumper
          </div>
          <div className={"warning " + this.state.showing_warning}>
            <i class="bi bi-exclamation-octagon-fill"></i> Only Donald J. Trump
            can write a post. We dont allow fake news.
          </div>
          <div className="inputBox">
            <img
              src="https://ceris-gratton-jones.com/wp-content/uploads/2018/10/profile-picture-placeholder.png"
              alt=""
            />
            <input
              placeholder="Anything to complain about?"
              type="text"
              name=""
              id="writeTweet"
            />
          </div>
          <div className="buttons">
            <div className="left">
              <i class="bi bi-camera-fill"></i>
              <i class="bi bi-emoji-smile-fill"></i>
              <i class="bi bi-bar-chart-fill"></i>
            </div>
            <button onClick={this.displayWarning} className="right">
              Trump
            </button>
          </div>
        </div>
        <div className="tweets">
          {this.state.posts.map((post, index) => {
            return (
              <Tweet
                key={post.id}
                date={post.date}
                text={post.text}
                img={post.img}
                likes={post.likes}
                emoji={post.emoji}
              />
            );
          })}
        </div>

        <span className="copyright">
          Erstellt von{" "}
          <strong>
            <a
              target="_blank"
              href="https://www.instagram.com/alexander_jakob_/"
            >
              Alexander Jakob
            </a>{" "}
            <a target="_blank" href="https://www.whirlpool-king.de/impressum/">
              <img
                alt="Impressum / Whirlpool King (Alexander Jakob)"
                width="6"
                src="https://i.gyazo.com/006cf30ffda59192ab19c1e97c66de42.png"
              />
            </a>
          </strong>{" "}
          | Idee von "Der Postillon" (
          <strong>
            <a
              target="_blank"
              href="https://www.der-postillon.com/2021/01/trumper2.html"
            >
              Link zum Artikel
            </a>
          </strong>
          )
        </span>
      </div>
    );
  }
}
